import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  setPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
  inMemoryPersistence
} from 'firebase/auth';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { Capacitor } from '@capacitor/core';

// Your Firebase configuration
// Replace these values with your actual Firebase project configuration
const firebaseConfig = {
    apiKey: "AIzaSyDgqvKcGYt-1FKwfY0s8G3OU7feHBQl0B8",
    authDomain: "login.luminawellnessapp.com",
    databaseURL: "https://lumina-36895-default-rtdb.firebaseio.com",
    projectId: "lumina-36895",
    storageBucket: "lumina-36895.firebasestorage.app",
    messagingSenderId: "602186915685",
    appId: "1:602186915685:web:e2548c474ffacdd41e8b8c",
    measurementId: "G-Y8WGTVM8D5"
  };

  
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Configure persistence for web sign-in redirects (especially iOS browsers).
export const authPersistenceReady = Capacitor.isNativePlatform()
  ? Promise.resolve()
  : setPersistence(auth, browserLocalPersistence)
      .catch(() => setPersistence(auth, browserSessionPersistence))
      .catch(() => setPersistence(auth, inMemoryPersistence))
      .catch((error) => {
        console.warn('Failed to set auth persistence:', error);
      });

if (!Capacitor.isNativePlatform()) {
  void authPersistenceReady;
}

export const googleProvider = new GoogleAuthProvider();

// Initialize Analytics (only if supported)
export const analytics = isSupported().then(yes => yes ? getAnalytics(app) : null);

export default app;
